"use client";

import React from "react";
import type { IconProps } from "@/components/icons/icons-utils/icon-props";
import { useIconLayout } from "@/components/icons/icons-utils/use-icon-layout";

// MARK: ImageUp
/**
 * ImageUp icon — add SVG markup inside the root `<svg>`.
 *
 * **Reuse scope:** Project-wide — `@/components/icons` registry.
 */
export const ImageUp: React.FC<IconProps> = (props) => {
    const { resolved_width, resolved_height, effective_stroke_width, className, svg_style, rest } = useIconLayout(props);

    return (
        <svg
            viewBox="0 0 24 24"
            width={resolved_width}
            height={resolved_height}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            style={svg_style}
            strokeWidth={effective_stroke_width}
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
            {...rest}
        >
            <path d="M4.9984 2H2V4.9984H4.9984V2Z" ></path>
            <path d="M4.9978 3.50098H18.998" ></path>
            <path d="M3.49878 4.99805V19" ></path>
            <path d="M20.4968 4.99951V19.0015" ></path>
            <path d="M4.9978 20.501H18.998" ></path>
            <path d="M4.9984 19H2V21.9984H4.9984V19Z" ></path>
            <path d="M21.9964 2.00195H18.998V5.00035H21.9964V2.00195Z" ></path>
            <path d="M21.9964 19.002H18.998V22.0004H21.9964V19.002Z" ></path>
        </svg>
    );
};

ImageUp.displayName = "ImageUp";
